/**
 * Add item to selected items.
 * @param {array} items
 */
const selectItems = (items = []) => ({ setSelectedItems, selectedItems }) => {
  setSelectedItems([...new Set([...selectedItems, ...items])]);
};

/**
 * Add item to deselected items.
 * @param {array} items
 */
const deselectItems = (items = []) => ({ setDeselectedItems, deselectedItems }) => {
  setDeselectedItems([...new Set([...deselectedItems, ...items])]);
};

/**
 * Returns whether the provided item is selected.
 * @param {string|number} item
 * @returns {boolean}
 */
const isItemSelected = item => ({ allItemsSelected, deselectedItems, selectedItems }) => {
  if (allItemsSelected && deselectedItems.includes(item)) {
    return false;
  }

  return (
    allItemsSelected ||
    (!allItemsSelected && selectedItems?.length > 0 && selectedItems.includes(item))
  );
};

/**
 * Toggle the selection state of an item.
 * @param {string|number} item
 */
const toggleItemSelection = item => state => {
  const {
    allItemsSelected,
    setDeselectedItems,
    deselectedItems,
    selectedItems,
    setSelectedItems,
  } = state;

  const isSelected = isItemSelected(item)(state);

  if (allItemsSelected && isSelected) {
    setDeselectedItems([...new Set([...deselectedItems, item])]);
  }

  if (allItemsSelected && !isSelected) {
    setDeselectedItems(deselectedItems.filter(deselectedItem => deselectedItem !== item));
  }

  if (!allItemsSelected && isSelected) {
    setSelectedItems(selectedItems.filter(selectedItem => selectedItem !== item));
  }

  if (!allItemsSelected && !isSelected) {
    setSelectedItems([...new Set([...selectedItems, item])]);
  }
};

export default {
  selectItems,
  deselectItems,
  isItemSelected,
  toggleItemSelection,
};
